import React from 'react'

import Layout from '../components/Layout'
import {StaticQuery, graphql} from "gatsby";
import BlogList from '../components/blog/BlogList';
import PageTitle from '../components/PageTitle';

export default class BlogIndexPage extends React.Component {
    render() {
        return (
            <StaticQuery query={graphql` query {
                markdownRemark(frontmatter: {templateKey: {eq: "blog-page"}}) {
                   frontmatter {
                     templateKey
                     title
                   }
                }
                allMarkdownRemark(
                    sort: { order: DESC, fields: [frontmatter___date] }
                    filter: {frontmatter: {templateKey: {eq: "blog-post"}}}) {
                        edges {
                            node {
                                excerpt(pruneLength: 400)
                                id
                                fields {
                                    slug
                                }
                                rawMarkdownBody
                                html
                                frontmatter {
                                    title
                                    description
                                    date(formatString: "MMMM DD, YYYY")
                                    image {
                                        childImageSharp {
                                            gatsbyImageData(layout: CONSTRAINED)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `} render={data => (
                <Layout>
                    <PageTitle>{data.markdownRemark.frontmatter.title}</PageTitle>
                    <BlogList data={data}/>
                </Layout>
            )}/>
        )
    }
}
